import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import styled from 'styled-components';

const Container = styled.div`
    width: 100%;
    flex-grow: 1;
    height: auto;
    /* display: flex; */
    vertical-align: center;
`

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: 'transparent',
  },
  bar: {
    borderRadius: 5,
    backgroundColor: 'var(--focus-color)',
  },
}))(LinearProgress);

const Progress = props => {
    const {
        value,
        time
    } = props;
    const [counter, setCounter] = React.useState(time);
    React.useEffect(() => {
      console.log(counter)
      counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    }, [counter]);

    return (
        <Container>
            <BorderLinearProgress value={value || (100/counter)} variant='determinate'/>
        </Container>
    )
}

export default Progress